<template>
  <div class="page-box">
    <!--查询条件 -->
    <query-condition-box class="header">
      <datePicker :hasCurrent="1" @changeDate="changeDate"></datePicker>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-download"
        @click="exportList"
        >导出
      </el-button>
    </query-condition-box>
    <!-- 列表展示 -->
    <div class="result-container" v-loading="loading">
      <!-- 数据统计模块 -->
      <dataStatistics
        :type="'money'"
        :showInfo="showInfo"
        @changeData="changeShow"
        @toCashOut="toCashOut"
      ></dataStatistics>
      <ul class="money-list">
        <li class="money-header">
          <div class="header1">详情</div>
          <div class="header2">类型</div>
          <div class="header3">时间</div>
          <div class="header4">收支金额</div>
          <div class="header5">受益人</div>
        </li>
        <li class="money-li" v-for="(item, index) in list" :key="index">
          <div v-if="item.desc" :title="item.desc" class="li-info">
            {{ item.desc }}
          </div>
          <div
            v-else
            :title="'[' + item.resourceId + ']' + item.resourceName"
            class="li-info"
          >
            [{{ item.resourceId }}]{{ item.resourceName }}
          </div>
          <div class="li-type">{{ item.type }}</div>
          <div class="li-date">{{ item.createTime }}</div>
          <div class="li-num">{{ item.amount }}</div>
          <div class="li-user">{{ item.userName }}</div>
        </li>
        <li v-if="!list.length" class="not-data">暂无数据</li>
      </ul>
      <el-pagination
        v-show="total !== null && total !== 0"
        background
        style="text-align: right; padding: 10px"
        :current-page.sync="pageIndex"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <!-- 店铺认证弹窗 -->
    <auth-dialog
      :dialog-visible.sync="auth.flag"
      :tip-type="auth.tipType"
    ></auth-dialog>
    <!-- 分配收入弹窗 -->
    <el-dialog
      :title="diaType === 1 ? '分配收入' : '提示'"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <div v-if="diaType === 1" class="content">
        <xkw-table :data="subAccountList">
          <el-table-column label="用户名" prop="userName" align="center">
          </el-table-column>
          <el-table-column label="分配金额" prop="amount" align="center">
          </el-table-column>
          <el-table-column label="收入时间范围" align="center">
            <template slot-scope="scope">
              <span> {{ scope.row.startTime }}</span>
              <span> &nbsp;至&nbsp; </span>
              <span>{{ scope.row.endTime }}</span>
            </template>
          </el-table-column>
        </xkw-table>
        <div style="margin-top: 20px">
          <el-button type="primary" @click="shopSubAccount">确定分配</el-button>
        </div>
        <div style="margin-top: 20px">
          注意：分配后收入将从店铺转移至个人中心，可前往 个人中心-我的资产 查看
        </div>
      </div>
      <div v-else-if="diaType === 2" class="content">
        <div style="margin-top: 50px">
          收入已分配至个人中心，可前往 个人中心-我的资产 查看
        </div>
        <div class="btn_wrap">
          <el-button type="primary" plain @click="toMyAssets">去查看</el-button>
          <el-button type="primary" @click="handleClose">确定</el-button>
        </div>
      </div>
      <div v-else-if="diaType === 3" class="content">
        <div style="margin-top: 50px">{{ subErrorMes }}</div>
        <div style="margin: 50px 0 30px">
          <el-button type="primary" @click="handleClose">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/assets/js/api";
import dataStatistics from "../../components/operate/data-statistics.vue";
import datePicker from "../../components/common/date-picker.vue";
import AuthDialog from "@/components/auth-dialog.vue";
import { isOpenPermissionDialog } from "@/assets/js/utils";
export default {
  name: "ShopCenterAdminWebFund",

  data() {
    return {
      //查询参数
      queryParams: {
        shopId: this.$store.state.user.userInfo.shopId,
        //收支类型
        iotype: "0",
        //查询时间
        timeAlias: "month",
        //起始日期
        startTime: "",
        //结束日期
        endTime: "",
        //受益人
        provider: "",
      },
      showType: 0, // 类型筛选项 16-店铺收入 17-内容分成收入 18-可提现金额
      showMoneyType: 0, // 收入或支出类型 100-不限 110-收入 111-支出
      loading: false,
      showInfo: [],
      list: [], // 列表数据
      pageIndex: 1, // 当前页
      total: 0, // 总条数
      subAccountList: [], // 收入分配账号列表
      dialogVisible: false, // 弹窗
      diaType: 0, // 弹窗类型 1-收入分配 2-提现 3-错误
      subErrorMes: "", // 弹窗错误信息
      auth: {
        // 认证弹窗相关
        flag: false,
        tipType: null,
      },
    };
  },
  components: {
    dataStatistics,
    datePicker,
    AuthDialog,
  },
  mounted() {},
  methods: {
    // 切换时间段
    changeDate(e) {
      this.queryParams = e;
      this.showType = 0;
      this.showMoneyType = 0;
      this.pageIndex = 1;
      this.getAllCount();
    },
    // 获取顶部展示相关数据
    async getAllCount() {
      const params = {
        from: this.queryParams.startTime,
        to: this.queryParams.endTime,
      };
      const { result } = await this.$axios.post(
        api.dataAnalysis.getPropertyData,
        params
      );
      if (result) {
        const { feeBackMoney, shopIncomeNum, usableIncome } = result;
        this.showInfo = [
          shopIncomeNum.toFixed(2),
          feeBackMoney.toFixed(2),
          usableIncome.toFixed(2),
        ];
      }
    },
    // 获取收支明细列表相关数据
    async queryList() {
      this.loading = true;
      const params = {
        ...this.queryParams,
        pageIndex: this.pageIndex,
        pageSize: 10,
      };
      const res = await this.$axios.post(api.trade.pageIncomePayList, params);
      if (res.result) {
        const { incomePayPage } = res.result;
        this.list = incomePayPage.list;
        this.total = incomePayPage.totalCount;
      }
      this.loading = false;
    },
    // 切换收入或支出类型
    changeShow(e) {
      this.showMoneyType = e.id2;
      this.pageIndex = 1;
      switch (this.showMoneyType) {
        case 100:
          this.queryParams.iotype = 0;
          break;
        case 110:
          this.queryParams.iotype = 1;
          break;
        case 111:
          this.queryParams.iotype = 2;
          break;
      }
      this.queryList();
    },
    // 修改当前页
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.queryList();
    },
    // 导出列表数据
    exportList() {
      if (this.total > 10000) {
        this.$message.error("单次导出条数不能超过10000条");
        return;
      }
      window.open(
        "https://shopcenter.xkw.com/api/shop-center/export-income-pay-detail?startTime=" +
          this.queryParams.startTime +
          "&endTime=" +
          this.queryParams.endTime +
          "&time=" +
          this.queryParams.timeAlias +
          "&shopId=" +
          this.queryParams.shopId +
          "&iotype=" +
          this.queryParams.iotype
        // "&provider=" +
        // this.queryParams.provider
      );
    },

    // 提现/收入分配
    async toCashOut(e) {
      this.loading = true;
      // 判断是否认证 按钮是否有权限
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1) {
        this.loading = false;
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      // 1-提现 2-收入分配
      if (e === 1) {
        this.loading = false;
        // 跳转到提现页面
        window.open(
          `https://${
            process.env.NODE_ENV == "production" ? "" : "t"
          }account.xkw.com/#/property-index?withdraw=m`
        );
      } else if (e === 2) {
        // 弹窗展示收入分配账号列表
        const result = await this.$axios.get(
          "api/shop-center/get-sub-account-list"
        );
        this.loading = false;
        if (result.valid) {
          if (result.result) {
            this.subAccountList = result.result;
            this.dialogVisible = true;
            this.diaType = 1;
          } else {
            this.dialogVisible = true;
            this.diaType = 3;
            this.subErrorMes = result.error.message;
          }
        }
      }
    },
    // 确定分配收入
    async shopSubAccount() {
      this.dialogVisible = false;
      this.loading = true;
      const result = await this.$axios.post("api/shop-center/shop-sub-account");
      this.loading = false;
      if (result.valid) {
        this.dialogVisible = true;
        if (result.result) {
          this.diaType = 2;
        } else {
          this.diaType = 3;
          this.subErrorMes = result.error.message;
        }
      }
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.diaType = 0;
    },
    // 去查看-我的资产
    toMyAssets() {
      window.open(`https://user.zxxk.com/?order=19`);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.result-container {
  padding: 54px 20px 80px;
  background: #fff;
  border-radius: 5px;
  .money-list {
    margin-top: 30px;
    margin-bottom: 10px;
    .money-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 36px;
      border-radius: 4px 4px 0px 0px;
      border-bottom: 1px solid #e6ebf4;
      background: #f3f7fd;
      & > div {
        color: #606266;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 14px; /* 100% */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
      }
      .header1 {
        width: calc(40% - 30px);
        padding-left: 30px;
        text-align: left;
      }
      .header2 {
        width: 10%;
      }
      .header3 {
        width: 20%;
      }
      .header4 {
        width: 10%;
      }
      .header5 {
        width: 20%;
      }
    }
    .money-li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      // height: 50px;
      padding: 10px 0;
      border-bottom: 1px solid #e6ebf4;
      & > div {
        color: #3a3d4b;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px; /* 100% */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
      }
      .li-info {
        width: calc(40% - 30px);
        padding-left: 30px;
        text-align: left;
        white-space: normal;
        line-height: 22px;
      }
      .li-type {
        width: 10%;
      }
      .li-date {
        width: 20%;
      }
      .li-num {
        width: 10%;
      }
      .li-user {
        width: 20%;
      }
    }
    .not-data {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 200px;
      font-size: 14px;
      color: #999;
    }
  }
}
.content {
  max-height: 500px;
  overflow: auto;
  text-align: center;
}
.btn_wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 170px;
  margin: 50px auto 30px;
}
</style>
